<template>
    <div>
        <CoolLightBox
          :items="photos.data"
          :index="index"
          @close="index = null">
      </CoolLightBox>
        <template v-if="isZoomable === false">
            <div v-if="isNew" class="blue-dot-overlay btn-bg-color-secondary-blue"></div>
            <v-img :src="imageSrc" v-bind="$attrs" @click="$emit('click')" />
        </template>

        <template v-else>
            <inner-image-zoom class="details-zoomed-image" v-if="imageSrc" :src="imageSrc" :zoomSrc="imageSrcZoom" zoomType="hover" zoomPreload hideHint> </inner-image-zoom>

            <v-row v-else class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate class="dark-blue-color"></v-progress-circular>
            </v-row>
        </template>
        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip" v-if="showOpenImage()" >
            <template v-slot:activator="{ on, attrs }">
                <!--mdi-tooltip-image-->
                <v-icon style="color: rgb(0 109 182); caret-color: rgb(0 109 182);position: absolute;float: left;left: 12px;" v-on="on" v-bind="attrs" @click="openImage(imageSrc)" >mdi-fullscreen</v-icon>
            </template>
            <span>{{ tb('Ver Imagem') }}</span>
        </v-tooltip>
    </div>
</template>

<script>
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import InnerImageZoom from 'vue-inner-image-zoom';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';

export default {
    components: {
        'inner-image-zoom': InnerImageZoom,
        CoolLightBox
    },

    props: {
        productCode: String,

        isZoomable: {
            type: Boolean,
            default: false,
        },

        isNew: {
            type: Boolean,
            default: false,
        },

        imageSrc: {
            type: String,
            default: null,
        },
        imageSrcZoom: {
            type: String,
            default: null,
        },
        btnFullScreen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
      return {
        photos: { data:[] },
        index:null
      }
    },
    computed: {
        ...mapStores(useUserStore),
    },
    methods:{
        showOpenImage() {
            if(this.btnFullScreen){
                return this.userStore.hasPermissionTo('See Product Image In Fullscreen') ;
            }
            return false
        },
        openImage(url){
            //window.open(url, '_blank');
            this.photos.data=[]
            this.photos.data.push({ id:1,src:url})
            this.index=0
        }
    }
};
</script>

<style>
.blue-dot-overlay {
    height: 8px;
    width: 8px;
    border-radius: 100%;
    position: absolute;
    overflow: visible;
    border: 1px solid #0d7ebf;
    right: 31px;
    bottom: 31px;
    z-index: 1;
}

.details-zoomed-image {
    width: 320px !important;
    height: 30vh !important;
    max-height: 30vh !important;
}

figure.details-zoomed-image > div {
    width: 320px !important;
    height: 30vh !important;
    max-height: 30vh !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

figure.details-zoomed-image > div > picture > img {
    max-height: 30vh !important;
}

.details-image-side-div {
    /* from v-img, doesn't work with the zoom component due to the different structures */
    padding-bottom: 100%;
    transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
    flex: 1 0 0px;
}

.details-image {
    /* background-image: url(http://localhost/storage/uploads/products/05032.jpg); */
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
}

/* vue-image-zoom */
.iiz {
    cursor: default !important;
}

.iiz__zoom-img--visible {
    cursor: default !important;
}
</style>
